// import React, { useState, useEffect } from "react";
// import Popup from "../../../../ResuableCompoment/Popup";
// import { useSelector, useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import Loading from "../../../../ResuableCompoment/Loading";
// import useApi from "../../../../CustomHooks/useApi";
// import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
// import ReactDOMServer from 'react-dom/server';
// import PrintComponent from '../../../../ResuableCompoment/PrintComponent';

// const FundTransfer = () => {

//   const location = useLocation();
//   const navigate = useNavigate();

//   const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
//   const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
//   const remitter_availableLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitAvailable);
//   const remitter_consumeLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitConsumed);
//   const remitter_limitTotal = useSelector((state) => state.auth.remitterData?.remitter_data?.limitTotal);
//   const impsType = useSelector((state) => state.auth.remitterData?.type);
//   const instRef = useSelector((state) => state.auth.remitterData?.reference_key);

//   const selectedBeneficiary = location.state?.selectedBeneficiary;
//   console.log("selectedBeneficiarydataa", selectedBeneficiary);
//   const merchantaccountno = useSelector((store) => store.auth.employeeDetails.merchant_account_no);
//   const username = useSelector((store) => store.auth.employeeDetails.username);
//   const merchantid = useSelector((store) => store.auth.employeeDetails.userId);
//   const [total, setTotal] = useState(0);
//   const [txnId, setTxnId] = useState("");
//   const [insttxnId, setInsttxnId] = useState("");
//   const [transactions, setTransactions] = useState([]);
//   const [splitTtransactions, setSplitTtransactions] = useState([]);
//   const [popupMessage, setPopupMessage] = useState("");
//   const [popupType, setPopupType] = useState("");
//   const [showPopup1, setShowPopup1] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedTransaction, setSelectedTransaction] = useState([]);
//   const [sendOtpLoading, setSendOtpLoading] = useState({});
//   const [otpValues, setOtpValues] = useState({});
//   const [otpEntered, setOtpEntered] = useState({});
//   const [otpShow, setOtpShow] = useState({});
//   const [otpData, setOtpData] = useState({});
//   const [currentIndex, setCurrentIndex] = useState(null);
//   const [error, setError] = useState("");
//   const [otpAttempts, setOtpAttempts] = useState({});
//   const [mpin, setMpin] = useState("");
//   const [mpinValues, setMpinValues] = useState({});
//   const [tabletxnId, setTabletxnId] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [completedTxns, setCompletedTxns] = useState({});
//   const [finishedTxns, setFinishedTxns] = useState({});
//   const [stopFurtherOtp, setStopFurtherOtp] = useState(false);

//   const [record, setRecord] = useState(null);
//   const [txnList, setTxnList] = useState([]);

//   const dispatch = useDispatch();

//   const { callApi: calculate } = useApi("/dmt/fee/calculate", "POST");
//   const { callApi: otpsend } = useApi("/dmt/sendOtp", "POST");
//   const { callApi: inisiate } = useApi("/dmt/transfer/money", "POST");
//   const { callApi: compelete } = useApi("/dmt/transfer/money", "POST");
//   const { callApi: bulkprint } = useApi("/dmt/buikPrint", "GET");

//   useEffect(() => {
//     const fetchTransactions = async () => {
//       if (selectedBeneficiary[0]?.amount) {
//         const result = await calculatetransction(selectedBeneficiary[0].amount);
//         setSplitTtransactions(result);
//       }
//     };

//     fetchTransactions();
//   }, [selectedBeneficiary]);

//   const handleDownloadPdf = (record) => {
//     const receiptHTML = ReactDOMServer.renderToString(
//       <PrintComponent record={record} />
//     );

//     const container = document.createElement("div");
//     container.innerHTML = receiptHTML;

//     const options = {
//       margin: 10,
//       filename: `receipt_${record.txnId || "txn"}.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2, useCORS: true },
//       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//     };
//   };

//   useEffect(() => {
//     if (tabletxnId) {
//       bulkPrintHandler();
//     }
//   }, [tabletxnId]);


//   const bulkPrintHandler = async () => {
//     const txnIds = transactions.map((tx) => tx.id);
//     try {
//       const queryParams = txnIds.map((id) => `txnId=${id}`).join('&');
//       const finalUrl = `?merchant_user_name=${username}&${queryParams}`;
//       const response = await bulkprint(null, finalUrl);
//       console.error("Bulk print error", response.bulkCashOutTransactResponse);
//       console.error("Bulk print error2", response);
//       setRecord(response);
//       setTxnList(response?.bulkCashOutTransactResponse || []);
//     } catch (error) {
//       console.error("Bulk print error:", error);
//     }
//   };

//   const completeSingleImps1Transaction = async (index) => {
//     const otpEntry = otpData[index];

//     if (!otpEntry?.refId || !otpEntry?.otp) {
//       setError("OTP not verified for this transaction");
//       return;
//     }

//     if (!mpinValues[index] || mpinValues[index].length !== 6) {
//       setError("Please enter valid MPIN");
//       return;
//     }

//     const result = await completeTransaction(
//       otpEntry.refId,
//       otpEntry.otp,
//       otpEntry.totalamount,
//       otpEntry.txnamount,
//       null,
//       null,
//       mpinValues[index]
//     );

//     if (result?.status === "WALLET_DEBIT_FAILED") {
//       setError(result.customerSummary || "Insufficient wallet balance");

//       setFinishedTxns(prev => ({ ...prev, [index]: true }));

//       setStopFurtherOtp(true);

//       setOtpShow(prev => ({ ...prev, [index]: false }));
//       setOtpEntered(prev => ({ ...prev, [index]: false }));
//       setMpinValues(prev => ({ ...prev, [index]: "" }));

//       return;
//     }

//     if (result?.status === "SUCCESS") {
//       setTransactions(prev => [...prev, result]);
//       setCompletedTxns(prev => ({ ...prev, [index]: true }));
//       setFinishedTxns(prev => ({ ...prev, [index]: true }));

//       setOtpShow(prev => ({ ...prev, [index]: false }));
//       setOtpEntered(prev => ({ ...prev, [index]: false }));
//       setMpinValues(prev => ({ ...prev, [index]: "" }));

//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());
//       return;
//     }
//     if (result?.status === "PENDING") {
//       setFinishedTxns(prev => ({ ...prev, [index]: true }));
//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());
//       return;
//     }

//     if (result?.status === "FAILED") {
//       const errorMsg = result.customerSummary || "";
//       setError(
//         result.customerSummary ||
//         "Transaction failed. Please try again."
//       );
//       if (errorMsg.toLowerCase().includes("otp")) {

//     // clear OTP input
//     setOtpValues(prev => ({ ...prev, [index]: "" }));

//     // mark OTP as NOT entered so input stays editable
//     setOtpEntered(prev => ({ ...prev, [index]: false }));

//     // keep OTP input visible (DO NOT hide)
//     setOtpShow(prev => ({ ...prev, [index]: true }));

//     // ❌ IMPORTANT: do NOT mark finished
//     setFinishedTxns(prev => ({ ...prev, [index]: false }));

//     return;
//   }

//       setFinishedTxns(prev => ({ ...prev, [index]: true }));

//       setOtpEntered(prev => ({ ...prev, [index]: false }));
//       setMpinValues(prev => ({ ...prev, [index]: "" }));

//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());

//       return;
//     }

//     if (result?.status === "WALLET_DEBIT_FAILED") {
//       setError(
//         result.customerSummary ||
//         "Transaction failed. Please try again."
//       );

//       setOtpEntered(prev => ({ ...prev, [index]: false }));
//       setMpinValues(prev => ({ ...prev, [index]: "" }));

//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());

//       return;
//     }

//   };

//   const handlePrint = (record) => {
//     const receiptHTML = ReactDOMServer.renderToString(
//       <PrintComponent record={record} />
//     );

//     const printWindow = window.open('', '_blank');

//     if (!printWindow) {
//       alert('Please allow popups to print receipt');
//       return;
//     }

//     printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//       <head>
//         <title>Receipt</title>
//         <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             margin: 0;
//             padding: 12px;
//           }
//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }
//           table, th, td {
//             border: 1px solid #000;
//           }
//           th, td {
//             padding: 6px;
//             font-size: 12px;
//           }
//         </style>
//       </head>
//       <body>
//         ${receiptHTML}
//       </body>
//     </html>
//   `);

//     printWindow.document.close();

//     setTimeout(() => {
//       printWindow.focus();
//       printWindow.print();
//     }, 500);
//   };

//   const handleMpinChangeimps2 = (e) => {
//     const value = e.target.value;
//     if (/^\d{0,6}$/.test(value)) {
//       setMpin(value);
//     }
//   };
//   const handleMpinChange = (index, value) => {
//     if (/^\d{0,6}$/.test(value)) {
//       setMpinValues(prev => ({ ...prev, [index]: value }));
//     }
//   };

//   const handleInitiateTransaction = async (index) => {
//     setSendOtpLoading(prev => ({ ...prev, [index]: true }));
//     await initiateTransaction(index);
//   };

//   // const handleOtpChange = (index, value) => {
//   //   setOtpValues(prev => ({ ...prev, [index]: value }));

//   //   setOtpData(prev => ({
//   //     ...prev,
//   //     [index]: {
//   //       ...prev[index],
//   //       otp: value,
//   //       txnamount: splitTtransactions[index]?.amount,
//   //       totalamount: splitTtransactions[index]?.total,
//   //     }
//   //   }));

//   //   if (value.length === 4 || value.length === 6) {
//   //     setOtpEntered(prev => ({ ...prev, [index]: true }));
//   //   }
//   // };

//   const handleOtpChange = (index, value) => {
//     setOtpValues(prev => ({ ...prev, [index]: value }));

//     setOtpData(prev => ({
//       ...prev,
//       [index]: {
//         ...prev[index],
//         otp: value,
//         txnamount: splitTtransactions[index]?.amount,
//         totalamount: splitTtransactions[index]?.total,
//       }
//     }));

//     // Check if the OTP is fully typed (4 or 6 digits)
//     if (value.length === 4 || value.length === 6) {
//       setOtpEntered(prev => ({ ...prev, [index]: true }));
      
//       // For IMPS2, once the OTP is fully typed, mark this step as "finished" 
//       // so the nextAllowedIndex can increment and unlock the next Send OTP button.
//       if (impsType === "IMPS2") {
//           setFinishedTxns(prev => ({ ...prev, [index]: true }));
//       }
//     } else {
//       // If the user deletes a digit, revert the states
//       setOtpEntered(prev => ({ ...prev, [index]: false }));
//       if (impsType === "IMPS2") {
//           setFinishedTxns(prev => ({ ...prev, [index]: false }));
//       }
//     }
//   };


//   const initiateTransaction = async (index) => {
//     if (impsType === "IMPS2") setLoading(true);
//     setError("");

//     try {
//       const transferAmount = splitTtransactions[index]?.amount;
//       const totalamount = splitTtransactions[index]?.total;

//       const cleanedTotalAmount = Number(String(totalamount).replace(/[^0-9.]/g, ""));
//       const cleanedTransferAmount = Number(String(transferAmount).replace(/[^0-9.]/g, ""));

//       const requestBody = {
//         userName: username,
//         imps_type: impsType,
//         referenceKey: instRef,
//         merchant_id: merchantid,

//         remitter_mobile_no: remitter_mobile_number,
//         remitter_name: remitter_fullname,

//         beneficiary_account_no: selectedBeneficiary[0]?.accountNo,
//         bene_name: selectedBeneficiary[0]?.beneficiaryName,
//         bank_name: selectedBeneficiary[0]?.bankName,
//         ifsc: selectedBeneficiary[0]?.ifscCode,

//         txn_amount: cleanedTotalAmount,
//         net_amount: cleanedTransferAmount,
//         payment_mode: selectedBeneficiary[0]?.mode,
//         merchant_account_no: merchantaccountno,
//         otp: "",
//         txnId: ""
//       };

//       const data = await inisiate(requestBody);

//       if (data?.error_code === "DMT001") {
//         setOtpData(prev => ({
//           ...prev,
//           [index]: {
//             refId: data.action_params?.trxnId,
//             txnamount: splitTtransactions[index]?.amount,
//             totalamount: splitTtransactions[index]?.total,
//             otp: ""
//           }
//         }));
//         setOtpShow(prev => ({ ...prev, [index]: true }));
//         setCurrentIndex(index);
//         return;
//       }

//       if (data?.status === "OTP_SENT") {
//         setInsttxnId(data.txnId);
//         setOtpShow(prev => ({ ...prev, [index]: true }));
//         setOtpData(prev => ({
//           ...prev,
//           [index]: {
//             instpaytxnId: data?.txnId,
//             txnamount: splitTtransactions[index]?.amount,
//             totalamount: splitTtransactions[index]?.total,
//             otp: otpValues[index],
//             referenceKey: data?.otpData?.referenceKey
//           }
//         }));
//         setCurrentIndex(index);
//         return;
//       }
//       throw new Error(data?.message || "Failed to send OTP");

//     } catch (err) {
//       console.error("Transaction initiation failed", err);
//       setError(err.message || "Failed to send OTP");
//     } finally {
//       setLoading(false);
//       setSendOtpLoading(prev => ({ ...prev, [index]: false }));
//     }
//   };

//   const completeTransaction = async (refId, otp, totalamount, txnamount, referenceKey, instpaytxnId, mpinValue) => {
//     setIsLoading(true);

//     const cleanedTotalAmount = Number(String(totalamount).replace(/[^0-9.]/g, ""));
//     const cleanedTxnAmount = Number(String(txnamount).replace(/[^0-9.]/g, ""));
//     try {
//       const requestBody = {
//         userName: username,
//         imps_type: impsType,

//         remitter_mobile_no: remitter_mobile_number,
//         remitter_name: remitter_fullname,

//         // bene_id: selectedBeneficiary[0]?.bene_id,
//         bene_id: selectedBeneficiary[0]?.id,
//         bene_name: selectedBeneficiary[0]?.beneficiaryName,
//         bank_name: selectedBeneficiary[0]?.bankName,
//         ifsc: selectedBeneficiary[0]?.ifscCode,

//         beneficiary_account_no: selectedBeneficiary[0]?.accountNo,
//         net_amount: cleanedTxnAmount,
//         txn_amount: cleanedTotalAmount,
//         payment_mode: selectedBeneficiary[0]?.mode,
//         otp: otp,
//         txnId: refId,
//         merchant_account_no: merchantaccountno,
//         bank_code: selectedBeneficiary[0]?.bankCode,
//         mpin: impsType === "IMPS1" ? mpinValue : mpin
//       };
//       const requestinstBody = {
//         userName: username,
//         remitter_mobile_no: remitter_mobile_number,
//         beneficiary_account_no: selectedBeneficiary[0]?.accountNo,
//         net_amount: cleanedTotalAmount,
//         txn_amount: cleanedTxnAmount,
//         payment_mode: selectedBeneficiary[0]?.mode,
//         otp: otp,
//         merchant_id: merchantid,
//         imps_type: impsType,
//         txnId: instpaytxnId,
//         referenceKey: referenceKey,
//         merchant_account_no: merchantaccountno,
//         bank_code: selectedBeneficiary[0]?.bankCode,
//         mpin: mpin
//       }

//       const requestHeaders = {
//         Cookie: "JSESSIONID=A839C7E986CC50D62049244503766A47",
//       };

//       const data = await compelete(impsType === "IMPS2" ? requestinstBody : requestBody, null, requestHeaders);
//       console.log("dataaawrror", data);
//       if (data.error_code === "DMT050") {
//         setError(data.message)
//         return { status: data.error_code };
//       } else {
//         return {
//           id: data.txnId,
//           amount: data.amount,
//           total: total,
//           status: data.status,
//           customerSummary: data.customerSummary,
//         };
//       }
//     } catch (error) {
//       console.error("Transaction completion failed", error);
//       return {
//         id: refId,
//         amount: 0,
//         total: 0,
//         status: "Failed",
//       };
//     } finally {
//       setIsLoading(false);
//       dispatch(fetchWalletBalance());
//     }
//   };

//   const handleCompleteTransactions = async () => {
//     setIsLoading(true);
//     setError("");
//     if (impsType === "IMPS1") {
//       setIsLoading(false);
//       return;
//     }

//     const transactionResults = [];

//     for (let index = 0; index < splitTtransactions.length; index++) {
//       const otpEntry = otpData[index];

//       if (
//         !otpEntry?.otp ||
//         !(otpEntry.otp.trim().length === 4 || otpEntry.otp.trim().length === 6)
//       ) {
//         setIsLoading(false);
//         setError(`Please enter a valid OTP for transaction ${index + 1}.`);
//         return;
//       }

//       if (impsType === "IMPS2") {
//         if (!otpEntry?.instpaytxnId) {
//           setIsLoading(false);
//           setError(
//             `Transaction ID missing for transaction ${index + 1}.`
//           );
//           return;
//         }
//       } else {
//         if (!otpEntry?.refId) {
//           setIsLoading(false);
//           setError(
//             `Transaction reference ID missing for transaction ${index + 1}.`
//           );
//           return;
//         }
//       }
//     }

//     for (let index = 0; index < splitTtransactions.length; index++) {
//       const otpEntry = otpData[index];

//       const result = await completeTransaction(
//         impsType === "IMPS2"
//           ? otpEntry.instpaytxnId
//           : otpEntry.refId,
//         otpEntry.otp,
//         otpEntry.txnamount,
//         otpEntry.totalamount,
//         otpEntry.referenceKey,
//         otpEntry.instpaytxnId
//       );

//       if (result?.status === "DMT050") {
//         setIsLoading(false);
//         return;
//       }

//       transactionResults.push(result);
//     }

//     setIsLoading(false);
//     setTransactions(prev => [...prev, ...transactionResults]);
//     setTabletxnId(true);
//     dispatch(fetchWalletBalance());
//   };

//   const handleSelectTransaction = (index) => {
//     if (otpEntered[index] || completedTxns[index]) return;
//     setSelectedTransaction((prev) =>
//       prev.includes(index)
//         ? prev.filter((i) => i !== index)
//         : [...prev, index]
//     );
//   };

//   const feeCalculate = async (amount) => {
//     try {
//       const requestbody = {
//         imps_type: impsType,
//         provider: "DMT",
//         sub_provider: impsType === "IMPS1" ? "EZYPAY" : "INSTANTPAY",
//         amount: amount,
//         commercial_type: "TRANSACTION_FEE",
//         mid: username
//       };

//       const datafeee = await calculate(requestbody);

//       if (datafeee?.fee) {
//         return datafeee.fee;
//       }
//       return 0;
//     } catch (error) {
//       console.log("API Error:", error);
//       return 0;
//     }
//   };


//   const calculatetransction = async (amount) => {
//     const rows = [];
//     const maxLimit = 5000;
//     const minAmount = 100;
//     let remainingAmount = parseFloat(amount) || 0;

//     if (remainingAmount < minAmount) {
//       console.error("Minimum transaction amount is ₹100");
//       return [];
//     }

//     while (remainingAmount > 0) {
//       let transferAmount;

//       if (remainingAmount <= maxLimit) {
//         transferAmount = remainingAmount;
//       } else {
//         const afterThisSplit = remainingAmount - maxLimit;

//         if (afterThisSplit >= minAmount) {
//           transferAmount = maxLimit;
//         } else {
//           transferAmount = remainingAmount - minAmount;

//           if (transferAmount < minAmount) {
//             transferAmount = remainingAmount;
//           }
//         }
//       }

//       const fee = await feeCalculate(transferAmount);
//       const total = transferAmount + fee;

//       rows.push({
//         amount: transferAmount,
//         fee: fee.toFixed(2),
//         total: total.toFixed(2),
//       });

//       remainingAmount -= transferAmount;

//       if (rows.length > 50) {
//         console.error("Too many iterations in transaction splitting");
//         break;
//       }
//     }

//     console.log("Final Rows with Fees:", rows);
//     return rows;
//   };

//   const allOtpsEntered = splitTtransactions.length > 0 && splitTtransactions.every((_, index) => otpEntered[index] === true);

//   const nextAllowedIndex = stopFurtherOtp
//     ? -1
//     : splitTtransactions.findIndex((_, idx) => !finishedTxns[idx]);

//   return (
//     <>
//       {isLoading && <Loading isOpen={isLoading} />}
//       {showPopup1 && (
//         <Popup
//           message={popupMessage}
//           type={popupType}
//           onClose={() => setShowPopup1(false)}
//         />
//       )}

//       <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
//         <div className="max-w-7xl mx-auto px-4 space-y-8">

//           {/* ===== SUMMARY CARDS ===== */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {/* Beneficiary */}
//             <div className="bg-white/90 backdrop-blur-xl rounded-3xl
//                           border border-slate-200
//                           shadow-[0_25px_70px_-25px_rgba(0,0,0,0.35)]
//                           p-6">
//               <h2 className="text-xl font-semibold text-slate-900 mb-4">
//                 Beneficiary Details
//               </h2>
//               <div className="space-y-2 text-sm">
//                 <p><span className="font-medium">Name:</span> {selectedBeneficiary[0]?.beneficiaryName}</p>
//                 <p><span className="font-medium">Bank:</span> {selectedBeneficiary[0]?.bankName}</p>
//                 <p><span className="font-medium">Account:</span> {selectedBeneficiary[0]?.accountNo}</p>
//                 <p><span className="font-medium">IFSC:</span> {selectedBeneficiary[0]?.ifscCode}</p>
//               </div>
//             </div>

//             {/* Remitter */}
//             <div className="bg-white/90 backdrop-blur-xl rounded-3xl
//                           border border-slate-200
//                           shadow-[0_25px_70px_-25px_rgba(0,0,0,0.35)]
//                           p-6">
//               <h2 className="text-xl font-semibold text-slate-900 mb-4">
//                 Remitter Details
//               </h2>
//               <div className="space-y-2 text-sm">
//                 <p><span className="font-medium">Name:</span> {remitter_fullname}</p>
//                 <p><span className="font-medium">Mobile:</span> {remitter_mobile_number}</p>
//               </div>

//               <div className="flex flex-wrap gap-3 mt-4">
//                 <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700">
//                   Available ₹{remitter_availableLimit}
//                 </span>
//                 <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-700">
//                   Consumed ₹{remitter_consumeLimit}
//                 </span>
//                 <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700">
//                   Total ₹{remitter_limitTotal}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {!tabletxnId ? (
//             <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

//               {/* ================= MOBILE VIEW ================= */}
//               <div className="block md:hidden p-4 space-y-4">
//                 {error && <p className="text-rose-600 text-sm">{error}</p>}

//                 {splitTtransactions.map((row, index) => (
//                   <div
//                     key={index}
//                     className={`rounded-2xl border p-4 space-y-3
//             ${selectedTransaction.includes(index)
//                         ? "border-indigo-500 bg-indigo-50"
//                         : "border-slate-200 bg-white"}`}
//                   >
//                     {/* HEADER */}
//                     <div className="flex justify-between items-center">
//                       <label className="flex items-center gap-2">
//                         <input
//                           type="checkbox"
//                           checked={selectedTransaction.includes(index)}
//                           onChange={() => handleSelectTransaction(index)}
//                           // disabled={otpEntered[index]}
//                           disabled={otpEntered[index] || completedTxns[index]}
//                         />
//                         <span className="font-semibold">
//                           Transaction #{index + 1}
//                         </span>
//                       </label>

//                       <span className="text-sm font-semibold text-indigo-600">
//                         {selectedBeneficiary[0]?.mode}
//                       </span>
//                     </div>

//                     {/* AMOUNTS */}
//                     <div className="grid grid-cols-3 text-sm gap-2">
//                       <div>
//                         <p className="text-slate-500">Amount</p>
//                         <p className="font-semibold">₹{row.amount}</p>
//                       </div>
//                       <div>
//                         <p className="text-slate-500">Fee</p>
//                         <p className="font-semibold">₹{row.fee}</p>
//                       </div>
//                       <div>
//                         <p className="text-slate-500">Total</p>
//                         <p className="font-semibold">₹{row.total}</p>
//                       </div>
//                     </div>

//                     {/* OTP */}
//                     {otpShow[index] && (
//                       <input
//                         type="text"
//                         inputMode="numeric"
//                         maxLength={6}
//                         placeholder="Enter OTP"
//                         value={otpValues[index] || ""}
//                         onChange={(e) => {
//                           if (/^\d{0,6}$/.test(e.target.value)) {
//                             handleOtpChange(index, e.target.value);
//                           }
//                         }}
//                         disabled={completedTxns[index]}
//                         className="w-full px-4 py-3 rounded-xl border border-slate-300
//                          focus:border-indigo-600 outline-none text-center"
//                       />
//                     )}

//                     {otpEntered[index] && impsType === "IMPS1" && (
//                       <div className="space-y-3">
//                         <input
//                           type="password"
//                           maxLength={6}
//                           placeholder="Enter MPIN"
//                           value={mpinValues[index] || ""}
//                           onChange={(e) => handleMpinChange(index, e.target.value)}
//                           className="w-full px-4 py-3 rounded-xl border text-center"
//                         />

//                         <button
//                           // disabled={mpinValues[index]?.length !== 6}
//                           disabled={
//                             mpinValues[index]?.length !== 6 ||
//                             completedTxns[index]
//                           }
//                           onClick={() => completeSingleImps1Transaction(index)}
//                           className={`w-full py-3 rounded-xl text-white font-semibold
//         ${mpinValues[index]?.length === 6
//                               ? "bg-emerald-600"
//                               : "bg-slate-300 cursor-not-allowed"
//                             }`}
//                         >
//                           Complete Transaction
//                         </button>
//                       </div>
//                     )}

//                     {completedTxns[index] && (
//                       <div className="text-emerald-600 font-semibold text-sm text-center py-2">
//                         ✅ Transaction Successful
//                       </div>
//                     )}

//                     {!completedTxns[index] && (
//                       <button
//                         onClick={() => handleInitiateTransaction(index)}
//                         disabled={
//                           stopFurtherOtp ||
//                           index !== nextAllowedIndex ||
//                           !selectedTransaction.includes(index) ||
//                           otpEntered[index] ||
//                           finishedTxns[index]
//                         }
//                         className={`w-full py-3 rounded-xl text-sm font-semibold text-white
//       ${index === nextAllowedIndex &&
//                             selectedTransaction.includes(index) &&
//                             !otpEntered[index] &&
//                             !finishedTxns[index] &&
//                             !stopFurtherOtp
//                             ? "bg-gradient-to-r from-indigo-600 to-cyan-500"
//                             : "bg-slate-300 cursor-not-allowed"
//                           }`}
//                       >
//                         {sendOtpLoading[index] ? "Sending OTP…" : "Send OTP"}
//                       </button>
//                     )}
//                   </div>
//                 ))}
//                 {impsType === "IMPS2" && allOtpsEntered && (
//                   <div className="pt-4 border-t">
//                     <label className="block text-sm font-medium mb-2">
//                       Enter 6-digit MPIN
//                     </label>
//                     <input
//                       type="password"
//                       value={mpin}
//                       maxLength={6}
//                       onChange={(e) => handleMpinChangeimps2(e)}
//                       className="w-full px-4 py-3 rounded-xl border border-slate-300
//                        focus:border-indigo-600 outline-none"
//                     />

//                     {mpin.length === 6 && (
//                       <button
//                         onClick={handleCompleteTransactions}
//                         className="mt-4 w-full py-4 rounded-2xl text-white font-semibold
//                          bg-gradient-to-r from-indigo-600 to-cyan-500 shadow-lg"
//                       >
//                         Complete Transfer
//                       </button>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* ================= DESKTOP VIEW ================= */}
//               <div className="hidden md:block">
//                 <div className="px-6 py-4 border-b border-slate-200">
//                   <h2 className="text-xl font-semibold text-slate-900">
//                     Fund Transfer Breakdown
//                   </h2>
//                 </div>

//                 {error && (
//                   <div className="px-6 py-3 text-sm text-rose-600">
//                     {error}
//                   </div>
//                 )}

//                 <div className="overflow-x-auto">
//                   <table className="w-full text-sm">
//                     <thead className="bg-slate-100">
//                       <tr>
//                         <th className="px-4 py-3 text-center">Select</th>
//                         <th className="px-4 py-3 text-center">#</th>
//                         <th className="px-4 py-3 text-right">Amount</th>
//                         <th className="px-4 py-3 text-right">Fee</th>
//                         <th className="px-4 py-3 text-right">Total</th>
//                         <th className="px-4 py-3 text-center">Mode</th>
//                         <th className="px-4 py-3 text-center">OTP</th>
//                         <th className="px-4 py-3 text-center">Action</th>
//                       </tr>
//                     </thead>

//                     <tbody className="divide-y">
//                       {splitTtransactions.map((row, index) => (
//                         <tr key={index} className="hover:bg-slate-50">
//                           <td className="px-4 py-3 text-center">
//                             <input
//                               type="checkbox"
//                               checked={selectedTransaction.includes(index)}
//                               onChange={() => handleSelectTransaction(index)}
//                               disabled={otpEntered[index] || completedTxns[index]}
//                             />
//                           </td>
//                           <td className="px-4 py-3 text-center">{index + 1}</td>
//                           <td className="px-4 py-3 text-right">₹{row.amount}</td>
//                           <td className="px-4 py-3 text-right">₹{row.fee}</td>
//                           <td className="px-4 py-3 text-right font-semibold">₹{row.total}</td>
//                           <td className="px-4 py-3 text-center">
//                             {selectedBeneficiary[0]?.mode}
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             {otpShow[index] && (
//                               <input
//                                 type="text"
//                                 maxLength={6}
//                                 value={otpValues[index] || ""}
//                                 onChange={(e) => {
//                                   if (/^\d{0,6}$/.test(e.target.value)) {
//                                     handleOtpChange(index, e.target.value);
//                                   }
//                                 }}
//                                 disabled={completedTxns[index]}
//                                 className="w-24 px-2 py-1 rounded-lg border text-center"
//                               />
//                             )}
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             {otpShow[index] && (
//                               <>
//                                 {otpEntered[index] && impsType === "IMPS1" && (
//                                   <div className="mt-2 space-y-2">
//                                     <input
//                                       type="password"
//                                       maxLength={6}
//                                       placeholder="Enter MPIN"
//                                       value={mpinValues[index] || ""}
//                                       onChange={(e) => handleMpinChange(index, e.target.value)}
//                                       disabled={completedTxns[index]}
//                                       className="w-24 px-2 py-1 rounded-lg border text-center"
//                                     />

//                                     <button
//                                       disabled={
//                                         mpinValues[index]?.length !== 6 ||
//                                         completedTxns[index]
//                                       }
//                                       onClick={() => completeSingleImps1Transaction(index)}
//                                       className={`w-full px-2 py-1 rounded-lg text-xs font-semibold text-white
//               ${mpinValues[index]?.length === 6
//                                           ? "bg-emerald-600"
//                                           : "bg-slate-300 cursor-not-allowed"
//                                         }`}
//                                     >
//                                       Complete
//                                     </button>
//                                   </div>
//                                 )}
//                               </>
//                             )}
//                           </td>
//                           <td className="px-4 py-3 text-center">

//                             {completedTxns[index] && (
//                               <div className="text-emerald-600 font-semibold text-sm">
//                                 ✅ Transaction Successful
//                               </div>
//                             )}

//                             {!completedTxns[index] && (
//                               <button
//                                 onClick={() => handleInitiateTransaction(index)}
//                                 disabled={
//                                   stopFurtherOtp ||
//                                   index !== nextAllowedIndex ||
//                                   !selectedTransaction.includes(index) ||
//                                   otpEntered[index] ||
//                                   finishedTxns[index]
//                                 }
//                                 className={`px-4 py-2 rounded-xl text-xs font-semibold text-white
//         ${index === nextAllowedIndex &&
//                                     selectedTransaction.includes(index) &&
//                                     !otpEntered[index] &&
//                                     !finishedTxns[index] &&
//                                     !stopFurtherOtp
//                                     ? "bg-gradient-to-r from-indigo-600 to-cyan-500"
//                                     : "bg-slate-300 cursor-not-allowed"
//                                   }`}
//                               >
//                                 {sendOtpLoading[index] ? "Sending…" : "Send OTP"}
//                               </button>
//                             )}

//                           </td>

//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* {allOtpsEntered && ( */}
//                 {impsType === "IMPS2" && allOtpsEntered && (
//                   <div className="px-6 py-6 border-t">
//                     <label className="block text-sm font-medium mb-2">
//                       Enter 6-digit MPIN
//                     </label>
//                     <input
//                       type="password"
//                       value={mpin}
//                       maxLength={6}
//                       onChange={(e) => handleMpinChangeimps2(e)}
//                       className="w-full max-w-xs px-4 py-2 rounded-xl border"
//                     />

//                     {mpin.length === 6 && (
//                       <button
//                         onClick={handleCompleteTransactions}
//                         className="mt-4 px-8 py-3 rounded-xl text-white font-semibold
//                          bg-gradient-to-r from-indigo-600 to-cyan-500"
//                       >
//                         Complete Transfer
//                       </button>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ) : (
//             <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

//               {/* ================= MOBILE VIEW ================= */}
//               <div className="block md:hidden p-4 space-y-4">
//                 <h2 className="text-xl font-semibold text-slate-900">
//                   Transaction Summary
//                 </h2>

//                 {transactions.map((tx, index) => (
//                   <div
//                     key={tx.id || index}
//                     className="rounded-2xl border border-slate-200 p-4 space-y-2 bg-white"
//                   >
//                     <p className="text-sm">
//                       <span className="font-medium text-slate-600">Txn ID:</span><br />
//                       <span className="font-semibold break-all">{tx.id}</span>
//                     </p>

//                     <div className="flex justify-between text-sm">
//                       <span className="text-slate-600">Amount</span>
//                       <span className="font-semibold">₹{tx.amount}</span>
//                     </div>

//                     <div className="flex justify-between text-sm">
//                       <span className="text-slate-600">Status</span>
//                       <span
//                         className={`font-semibold
//                 ${tx.status === "SUCCESS"
//                             ? "text-emerald-600"
//                             : tx.status === "FAILED"
//                               ? "text-rose-600"
//                               : "text-amber-600"
//                           }`}
//                       >
//                         {tx.status}
//                       </span>
//                     </div>

//                     {tx.customerSummary && (
//                       <p className="text-xs text-slate-500">
//                         {tx.customerSummary}
//                       </p>
//                     )}
//                   </div>
//                 ))}

//                 {/* ACTIONS */}
//                 <div className="pt-4 space-y-3">
//                   <button
//                     onClick={() => navigate("/remittance")}
//                     className="w-full py-3 rounded-xl bg-slate-200 font-semibold"
//                   >
//                     New Transfer
//                   </button>

//                   <button
//                     onClick={handlePrint}
//                     className="w-full py-3 rounded-xl text-white font-semibold
//                      bg-gradient-to-r from-indigo-600 to-cyan-500"
//                   >
//                     Print Receipt
//                   </button>

//                   <button
//                     onClick={() => handleDownloadPdf(record)}
//                     className="mt-2 w-full py-2 rounded-lg bg-green-600 text-white text-sm font-semibold"
//                   >
//                     Download PDF
//                   </button>
//                 </div>
//               </div>

//               {/* ================= DESKTOP VIEW ================= */}
//               <div className="hidden md:block p-6">
//                 <h2 className="text-xl font-semibold mb-4">
//                   Transaction Summary
//                 </h2>

//                 <div className="overflow-x-auto">
//                   <table className="w-full text-sm">
//                     <thead className="bg-slate-100">
//                       <tr>
//                         <th className="px-4 py-3 text-left">Txn ID</th>
//                         <th className="px-4 py-3 text-right">Amount</th>
//                         <th className="px-4 py-3 text-center">Status</th>
//                         <th className="px-4 py-3 text-left">Description</th>
//                       </tr>
//                     </thead>

//                     <tbody className="divide-y divide-slate-200">
//                       {transactions.map((tx) => (
//                         <tr key={tx.id} className="hover:bg-slate-50">
//                           <td className="px-4 py-3">{tx.id}</td>
//                           <td className="px-4 py-3 text-right">₹{tx.amount}</td>
//                           <td className="px-4 py-3 text-center">
//                             <span
//                               className={`font-semibold
//                       ${tx.status === "SUCCESS"
//                                   ? "text-emerald-600"
//                                   : tx.status === "FAILED"
//                                     ? "text-rose-600"
//                                     : "text-amber-600"
//                                 }`}
//                             >
//                               {tx.status}
//                             </span>
//                           </td>
//                           <td className="px-4 py-3">
//                             {tx.customerSummary}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* DESKTOP ACTIONS */}
//                 <div className="flex justify-end gap-4 mt-6">
//                   <button
//                     onClick={() => navigate("/remittance")}
//                     className="px-6 py-2 rounded-xl bg-slate-200"
//                   >
//                     New Transfer
//                   </button>

//                   <button
//                     onClick={handlePrint}
//                     className="px-6 py-2 rounded-xl text-white
//                      bg-gradient-to-r from-indigo-600 to-cyan-500"
//                   >
//                     Print
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )
//           }
//         </div>
//       </div>
//     </>
//   );
// };

// export default FundTransfer;







import React, { useState, useEffect } from "react";
import Popup from "../../../../ResuableCompoment/Popup";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../../ResuableCompoment/Loading";
import useApi from "../../../../CustomHooks/useApi";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
import ReactDOMServer from 'react-dom/server';
import PrintComponent from '../../../../ResuableCompoment/PrintComponent';
import html2pdf from "html2pdf.js";

const FundTransfer = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
  const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
  const remitter_availableLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitAvailable);
  const remitter_consumeLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitConsumed);
  const remitter_limitTotal = useSelector((state) => state.auth.remitterData?.remitter_data?.limitTotal);
  const impsType = useSelector((state) => state.auth.remitterData?.type);
  const instRef = useSelector((state) => state.auth.remitterData?.reference_key);

  const selectedBeneficiary = location.state?.selectedBeneficiary;
  const merchantaccountno = useSelector((store) => store.auth.employeeDetails.merchant_account_no);
  const username = useSelector((store) => store.auth.employeeDetails.username);
  const merchantid = useSelector((store) => store.auth.employeeDetails.userId);
  
  const [total, setTotal] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [splitTtransactions, setSplitTtransactions] = useState([]);
  
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup1, setShowPopup1] = useState(false);
  
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [selectedTransaction, setSelectedTransaction] = useState([]);
  const [sendOtpLoading, setSendOtpLoading] = useState({});
  const [otpValues, setOtpValues] = useState({});
  const [otpEntered, setOtpEntered] = useState({});
  const [otpShow, setOtpShow] = useState({});
  const [otpData, setOtpData] = useState({});
  const [error, setError] = useState("");

  const [tabletxnId, setTabletxnId] = useState(false);
  const [completedTxns, setCompletedTxns] = useState({});
  const [finishedTxns, setFinishedTxns] = useState({});
  const [stopFurtherOtp, setStopFurtherOtp] = useState(false);

  // NEW: State for the Row-by-Row MPIN Modal
  const [mpinModalActive, setMpinModalActive] = useState({ isOpen: false, rowIndex: null });
  const [modalMpinValue, setModalMpinValue] = useState("");
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [record, setRecord] = useState(null);
  const [txnList, setTxnList] = useState([]);

  const dispatch = useDispatch();

  const { callApi: calculate } = useApi("/dmt/fee/calculate", "POST");
  const { callApi: inisiate } = useApi("/dmt/transfer/money", "POST");
  const { callApi: compelete } = useApi("/dmt/transfer/money", "POST");
  const { callApi: bulkprint } = useApi("/dmt/buikPrint", "GET");

  useEffect(() => {
    const fetchTransactions = async () => {
      if (selectedBeneficiary[0]?.amount) {
        const result = await calculatetransction(selectedBeneficiary[0].amount);
        setSplitTtransactions(result);
      }
    };
    fetchTransactions();
  }, [selectedBeneficiary]);

  
  const handleDownloadPdf = (record) => {
    const receiptHTML = ReactDOMServer.renderToString(
      <PrintComponent record={record} />
    );

    const container = document.createElement("div");
    container.innerHTML = receiptHTML;

    const options = {
      margin: 10,
      filename: `receipt_${record.txnId || "txn"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(container).save();
  };

  useEffect(() => {
    if (tabletxnId) {
      bulkPrintHandler();
    }
  }, [tabletxnId]);

  const bulkPrintHandler = async () => {
    const txnIds = transactions.map((tx) => tx.id);
    try {
      const queryParams = txnIds.map((id) => `txnId=${id}`).join('&');
      const finalUrl = `?merchant_user_name=${username}&${queryParams}`;
      const response = await bulkprint(null, finalUrl);
      setRecord(response);
      setTxnList(response?.bulkCashOutTransactResponse || []);
    } catch (error) {
      console.error("Bulk print error:", error);
    }
  };

  const handlePrint = (record) => {
    const receiptHTML = ReactDOMServer.renderToString(
      <PrintComponent record={record} />
    );
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Please allow popups to print receipt');
      return;
    }
    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Receipt</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
          body { font-family: Arial, sans-serif; margin: 0; padding: 12px; }
          table { width: 100%; border-collapse: collapse; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 6px; font-size: 12px; }
        </style>
      </head>
      <body>${receiptHTML}</body>
    </html>
  `);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 500);
  };

  const handleSelectTransaction = (index) => {
    if (otpEntered[index] || completedTxns[index]) return;
    setSelectedTransaction((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const feeCalculate = async (amount) => {
    try {
      const requestbody = {
        imps_type: impsType,
        provider: "DMT",
        sub_provider: impsType === "IMPS1" ? "EZYPAY" : "INSTANTPAY",
        amount: amount,
        commercial_type: "TRANSACTION_FEE",
        mid: username
      };
      const datafeee = await calculate(requestbody);
      if (datafeee?.fee) return datafeee.fee;
      return 0;
    } catch (error) {
      return 0;
    }
  };

  const calculatetransction = async (amount) => {
    const rows = [];
    const maxLimit = 5000;
    const minAmount = 100;
    let remainingAmount = parseFloat(amount) || 0;

    if (remainingAmount < minAmount) {
      console.error("Minimum transaction amount is ₹100");
      return [];
    }

    while (remainingAmount > 0) {
      let transferAmount;
      if (remainingAmount <= maxLimit) {
        transferAmount = remainingAmount;
      } else {
        const afterThisSplit = remainingAmount - maxLimit;
        if (afterThisSplit >= minAmount) {
          transferAmount = maxLimit;
        } else {
          transferAmount = remainingAmount - minAmount;
          if (transferAmount < minAmount) {
            transferAmount = remainingAmount;
          }
        }
      }
      const fee = await feeCalculate(transferAmount);
      const total = transferAmount + fee;
      rows.push({ amount: transferAmount, fee: fee.toFixed(2), total: total.toFixed(2) });
      remainingAmount -= transferAmount;
      if (rows.length > 50) break;
    }
    return rows;
  };

  const handleInitiateTransaction = async (index) => {
    setSendOtpLoading(prev => ({ ...prev, [index]: true }));
    setError("");

    try {
      const transferAmount = splitTtransactions[index]?.amount;
      const totalamount = splitTtransactions[index]?.total;
      const cleanedTotalAmount = Number(String(totalamount).replace(/[^0-9.]/g, ""));
      const cleanedTransferAmount = Number(String(transferAmount).replace(/[^0-9.]/g, ""));

      const requestBody = {
        userName: username,
        imps_type: impsType,
        referenceKey: instRef,
        merchant_id: merchantid,
        remitter_mobile_no: remitter_mobile_number,
        remitter_name: remitter_fullname,
        beneficiary_account_no: selectedBeneficiary[0]?.accountNo,
        bene_name: selectedBeneficiary[0]?.beneficiaryName,
        bank_name: selectedBeneficiary[0]?.bankName,
        ifsc: selectedBeneficiary[0]?.ifscCode,
        txn_amount: cleanedTotalAmount,
        net_amount: cleanedTransferAmount,
        payment_mode: selectedBeneficiary[0]?.mode,
        merchant_account_no: merchantaccountno,
        otp: "",
        txnId: ""
      };

      const data = await inisiate(requestBody);

      if (data?.error_code === "DMT001") {
        setOtpData(prev => ({
          ...prev,
          [index]: {
            refId: data.action_params?.trxnId,
            txnamount: splitTtransactions[index]?.amount,
            totalamount: splitTtransactions[index]?.total,
            otp: ""
          }
        }));
        setOtpShow(prev => ({ ...prev, [index]: true }));
        return;
      }

      if (data?.status === "OTP_SENT") {
        setOtpShow(prev => ({ ...prev, [index]: true }));
        setOtpData(prev => ({
          ...prev,
          [index]: {
            instpaytxnId: data?.txnId,
            txnamount: splitTtransactions[index]?.amount,
            totalamount: splitTtransactions[index]?.total,
            otp: otpValues[index],
            referenceKey: data?.otpData?.referenceKey
          }
        }));
        return;
      }
      throw new Error(data?.message || "Failed to send OTP");

    } catch (err) {
      setError(err.message || "Failed to send OTP");
    } finally {
      setSendOtpLoading(prev => ({ ...prev, [index]: false }));
    }
  };

  const handleOtpChange = (index, value) => {
    setOtpValues(prev => ({ ...prev, [index]: value }));
    setOtpData(prev => ({
      ...prev,
      [index]: { ...prev[index], otp: value }
    }));
    
    // Check if OTP is fully typed to unlock the "Verify & Pay" button
    if (value.length === 4 || value.length === 6) {
      setOtpEntered(prev => ({ ...prev, [index]: true }));
    } else {
      setOtpEntered(prev => ({ ...prev, [index]: false }));
    }
  };

  const completeTransaction = async (refId, otp, totalamount, txnamount, referenceKey, instpaytxnId, mpinValue) => {
    const cleanedTotalAmount = Number(String(totalamount).replace(/[^0-9.]/g, ""));
    const cleanedTxnAmount = Number(String(txnamount).replace(/[^0-9.]/g, ""));
    
    try {
      const requestBody = {
        userName: username,
        imps_type: impsType,
        remitter_mobile_no: remitter_mobile_number,
        remitter_name: remitter_fullname,
        bene_id: selectedBeneficiary[0]?.id,
        bene_name: selectedBeneficiary[0]?.beneficiaryName,
        bank_name: selectedBeneficiary[0]?.bankName,
        ifsc: selectedBeneficiary[0]?.ifscCode,
        beneficiary_account_no: selectedBeneficiary[0]?.accountNo,
        net_amount: cleanedTxnAmount,
        txn_amount: cleanedTotalAmount,
        payment_mode: selectedBeneficiary[0]?.mode,
        otp: otp,
        txnId: refId,
        merchant_account_no: merchantaccountno,
        bank_code: selectedBeneficiary[0]?.bankCode,
        mpin: mpinValue
      };
      
      const requestinstBody = {
        ...requestBody,
        merchant_id: merchantid,
        txnId: instpaytxnId,
        referenceKey: referenceKey,
      };

      const requestHeaders = { Cookie: "JSESSIONID=A839C7E986CC50D62049244503766A47" };
      const data = await compelete(impsType === "IMPS2" ? requestinstBody : requestBody, null, requestHeaders);
      
      if (data.error_code === "DMT050") {
        setError(data.message);
        return { status: data.error_code };
      }
      return { id: data.txnId, amount: data.amount, total: totalamount, status: data.status, customerSummary: data.customerSummary };
    } catch (error) {
      return { id: refId, amount: 0, total: 0, status: "FAILED" };
    }
  };

  // ==========================================
  // ROW-BY-ROW SUBMIT (TRIGGERS MODAL)
  // ==========================================
  const handleModalSubmit = async () => {
    const index = mpinModalActive.rowIndex;
    setIsModalLoading(true);
    setError("");

    const otpEntry = otpData[index];
    const ref = impsType === "IMPS2" ? otpEntry.instpaytxnId : otpEntry.refId;

    const result = await completeTransaction(
      ref,
      otpEntry.otp,
      otpEntry.totalamount,
      otpEntry.txnamount,
      otpEntry.referenceKey,
      otpEntry.instpaytxnId,
      modalMpinValue // Pass Modal MPIN
    );

    setIsModalLoading(false);

    if (result?.status === "WALLET_DEBIT_FAILED") {
      setError(result.customerSummary || "Insufficient wallet balance");
      markFinished(index, true);
      setStopFurtherOtp(true);
      closeModal();
    } 
    else if (result?.status === "SUCCESS") {
      setTransactions(prev => [...prev, result]);
      setCompletedTxns(prev => ({ ...prev, [index]: true }));
      markFinished(index, true);
      closeModal();
    } 
    else if (result?.status === "PENDING") {
      setTransactions(prev => [...prev, result]);
      markFinished(index, true);
      closeModal();
    } 
    else if (result?.status === "FAILED") {
      const errorMsg = result.customerSummary || "";
      setError(result.customerSummary || "Transaction failed. Please try again.");
      
      if (errorMsg.toLowerCase().includes("otp")) {
        // If OTP failed, clear OTP input, keep active so user can re-try
        setOtpValues(prev => ({ ...prev, [index]: "" }));
        setOtpEntered(prev => ({ ...prev, [index]: false }));
        closeModal();
      } else {
        setTransactions(prev => [...prev, result]);
        markFinished(index, true);
        closeModal();
      }
    } else {
       closeModal();
    }

    dispatch(fetchWalletBalance());
    dispatch(fetchAepsBalance());
    dispatch(fetchSettlementBalance());
  };

  const markFinished = (index, hideOtpInput) => {
      setFinishedTxns(prev => {
         const updated = { ...prev, [index]: true };
         checkIfAllFinished(updated);
         return updated;
      });
      if (hideOtpInput) {
          setOtpShow(prev => ({ ...prev, [index]: false }));
      }
  };

  const checkIfAllFinished = (currentFinishedStatus) => {
      const allDone = splitTtransactions.every((_, idx) => currentFinishedStatus[idx]);
      if (allDone) {
          setTabletxnId(true);
      }
  };

  const closeModal = () => {
      setMpinModalActive({ isOpen: false, rowIndex: null });
      setModalMpinValue("");
  };

  // Allow proceeding to the next row ONLY if the previous rows are finished
  const nextAllowedIndex = stopFurtherOtp ? -1 : splitTtransactions.findIndex((_, idx) => !finishedTxns[idx]);

  return (
    <>
      {isLoading && <Loading isOpen={isLoading} />}
      {showPopup1 && (
        <Popup
          message={popupMessage}
          type={popupType}
          onClose={() => setShowPopup1(false)}
        />
      )}

      {/* MPIN MODAL */}
      {mpinModalActive.isOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm p-8 text-center animate-[fadeIn_.2s_ease-out]">
            <h3 className="text-2xl font-bold text-slate-800 mb-2">Enter MPIN</h3>
            <p className="text-slate-500 text-sm mb-8">
              Verify Transaction #{mpinModalActive.rowIndex + 1}
            </p>

            <input
              type="password"
              maxLength={6}
              value={modalMpinValue}
              onChange={(e) => {
                if (/^\d{0,6}$/.test(e.target.value)) setModalMpinValue(e.target.value);
              }}
              className="w-full text-center tracking-[0.5em] text-3xl font-bold px-4 py-4 rounded-xl border border-slate-300 focus:border-indigo-600 outline-none mb-8"
              placeholder="••••••"
              autoFocus
            />

            <div className="flex gap-4">
              <button
                onClick={closeModal}
                className="flex-1 py-3.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold transition"
              >
                Cancel
              </button>
              <button
                onClick={handleModalSubmit}
                disabled={modalMpinValue.length !== 6 || isModalLoading}
                className="flex-1 py-3.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold disabled:opacity-50 transition"
              >
                {isModalLoading ? "Processing..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
        <div className="max-w-7xl mx-auto px-4 space-y-8">

          {/* ===== SUMMARY CARDS ===== */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl border border-slate-200 shadow-[0_25px_70px_-25px_rgba(0,0,0,0.35)] p-6">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">Beneficiary Details</h2>
              <div className="space-y-2 text-sm">
                <p><span className="font-medium">Name:</span> {selectedBeneficiary[0]?.beneficiaryName}</p>
                <p><span className="font-medium">Bank:</span> {selectedBeneficiary[0]?.bankName}</p>
                <p><span className="font-medium">Account:</span> {selectedBeneficiary[0]?.accountNo}</p>
                <p><span className="font-medium">IFSC:</span> {selectedBeneficiary[0]?.ifscCode}</p>
              </div>
            </div>

            <div className="bg-white/90 backdrop-blur-xl rounded-3xl border border-slate-200 shadow-[0_25px_70px_-25px_rgba(0,0,0,0.35)] p-6">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">Remitter Details</h2>
              <div className="space-y-2 text-sm">
                <p><span className="font-medium">Name:</span> {remitter_fullname}</p>
                <p><span className="font-medium">Mobile:</span> {remitter_mobile_number}</p>
              </div>
              <div className="flex flex-wrap gap-3 mt-4">
                <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700">Available ₹{remitter_availableLimit}</span>
                <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-700">Consumed ₹{remitter_consumeLimit}</span>
                <span className="px-4 py-1.5 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700">Total ₹{remitter_limitTotal}</span>
              </div>
            </div>
          </div>

          {!tabletxnId ? (
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

              {/* ================= MOBILE VIEW ================= */}
              <div className="block md:hidden p-4 space-y-4">
                {error && <p className="text-rose-600 text-sm font-semibold">{error}</p>}

                {splitTtransactions.map((row, index) => (
                  <div key={index} className={`rounded-2xl border p-4 space-y-3 ${selectedTransaction.includes(index) ? "border-indigo-500 bg-indigo-50" : "border-slate-200 bg-white"}`}>
                    
                    <div className="flex justify-between items-center">
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={selectedTransaction.includes(index)}
                          onChange={() => handleSelectTransaction(index)}
                          disabled={otpEntered[index] || finishedTxns[index]}
                        />
                        <span className="font-semibold">Transaction #{index + 1}</span>
                      </label>
                      <span className="text-sm font-semibold text-indigo-600">{selectedBeneficiary[0]?.mode}</span>
                    </div>

                    <div className="grid grid-cols-3 text-sm gap-2">
                      <div><p className="text-slate-500">Amount</p><p className="font-semibold">₹{row.amount}</p></div>
                      <div><p className="text-slate-500">Fee</p><p className="font-semibold">₹{row.fee}</p></div>
                      <div><p className="text-slate-500">Total</p><p className="font-semibold">₹{row.total}</p></div>
                    </div>

                    {otpShow[index] && (
                      <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter OTP"
                        value={otpValues[index] || ""}
                        onChange={(e) => {
                          if (/^\d{0,6}$/.test(e.target.value)) handleOtpChange(index, e.target.value);
                        }}
                        disabled={finishedTxns[index]}
                        className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-indigo-600 outline-none text-center tracking-widest text-lg font-bold"
                      />
                    )}

                    {finishedTxns[index] ? (
                       completedTxns[index] ? (
                         <div className="text-emerald-600 font-bold text-center py-2 bg-emerald-50 rounded-lg border border-emerald-200">✅ Transaction Successful</div>
                       ) : (
                         <div className="text-amber-600 font-bold text-center py-2 bg-amber-50 rounded-lg border border-amber-200">Transaction Processed</div>
                       )
                    ) : otpEntered[index] ? (
                       <button
                          onClick={() => setMpinModalActive({ isOpen: true, rowIndex: index })}
                          className="w-full py-3 rounded-xl bg-indigo-600 text-white font-bold shadow-md hover:bg-indigo-700"
                        >
                          Verify & Pay
                        </button>
                    ) : (
                      <button
                        onClick={() => handleInitiateTransaction(index)}
                        disabled={stopFurtherOtp || index !== nextAllowedIndex || !selectedTransaction.includes(index)}
                        className={`w-full py-3 rounded-xl text-sm font-bold text-white ${index === nextAllowedIndex && selectedTransaction.includes(index) && !stopFurtherOtp ? "bg-gradient-to-r from-indigo-600 to-cyan-500" : "bg-slate-300 cursor-not-allowed"}`}
                      >
                        {sendOtpLoading[index] ? "Sending OTP…" : "Send OTP"}
                      </button>
                    )}
                  </div>
                ))}
              </div>

              {/* ================= DESKTOP VIEW ================= */}
              <div className="hidden md:block">
                <div className="px-6 py-4 border-b border-slate-200">
                  <h2 className="text-xl font-semibold text-slate-900">Fund Transfer Breakdown</h2>
                </div>

                {error && <div className="px-6 py-3 text-sm font-semibold text-rose-600">{error}</div>}

                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-slate-100">
                      <tr>
                        <th className="px-4 py-3 text-center">Select</th>
                        <th className="px-4 py-3 text-center">#</th>
                        <th className="px-4 py-3 text-right">Amount</th>
                        <th className="px-4 py-3 text-right">Fee</th>
                        <th className="px-4 py-3 text-right">Total</th>
                        <th className="px-4 py-3 text-center">Mode</th>
                        <th className="px-4 py-3 text-center w-40">OTP</th>
                        <th className="px-4 py-3 text-center w-40">Action</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {splitTtransactions.map((row, index) => (
                        <tr key={index} className="hover:bg-slate-50">
                          <td className="px-4 py-3 text-center">
                            <input
                              type="checkbox"
                              checked={selectedTransaction.includes(index)}
                              onChange={() => handleSelectTransaction(index)}
                              disabled={otpEntered[index] || finishedTxns[index]}
                            />
                          </td>
                          <td className="px-4 py-3 text-center">{index + 1}</td>
                          <td className="px-4 py-3 text-right">₹{row.amount}</td>
                          <td className="px-4 py-3 text-right">₹{row.fee}</td>
                          <td className="px-4 py-3 text-right font-semibold">₹{row.total}</td>
                          <td className="px-4 py-3 text-center">{selectedBeneficiary[0]?.mode}</td>
                          <td className="px-4 py-3 text-center">
                            {otpShow[index] && (
                              <input
                                type="text"
                                maxLength={6}
                                value={otpValues[index] || ""}
                                onChange={(e) => {
                                  if (/^\d{0,6}$/.test(e.target.value)) handleOtpChange(index, e.target.value);
                                }}
                                disabled={finishedTxns[index]}
                                placeholder="OTP"
                                className="w-full px-2 py-2 rounded-lg border border-slate-300 text-center tracking-widest font-bold focus:border-indigo-600 outline-none"
                              />
                            )}
                          </td>
                          <td className="px-4 py-3 text-center">
                            {finishedTxns[index] ? (
                               completedTxns[index] ? (
                                 <span className="text-emerald-600 font-bold bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-200">✅ Success</span>
                               ) : (
                                 <span className="text-amber-600 font-bold bg-amber-50 px-3 py-1.5 rounded-lg border border-amber-200">Processed</span>
                               )
                            ) : otpEntered[index] ? (
                               <button
                                  onClick={() => setMpinModalActive({ isOpen: true, rowIndex: index })}
                                  className="w-full px-4 py-2 rounded-xl text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-700 shadow-md"
                               >
                                 Verify & Pay
                               </button>
                            ) : (
                               <button
                                  onClick={() => handleInitiateTransaction(index)}
                                  disabled={stopFurtherOtp || index !== nextAllowedIndex || !selectedTransaction.includes(index)}
                                  className={`w-full px-4 py-2 rounded-xl text-xs font-bold text-white ${index === nextAllowedIndex && selectedTransaction.includes(index) && !stopFurtherOtp ? "bg-gradient-to-r from-indigo-600 to-cyan-500 hover:shadow-md" : "bg-slate-300 cursor-not-allowed"}`}
                               >
                                 {sendOtpLoading[index] ? "Sending…" : "Send OTP"}
                               </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="block md:hidden p-4 space-y-4">
                <h2 className="text-xl font-semibold text-slate-900">Transaction Summary</h2>
                {transactions.map((tx, index) => (
                  <div key={tx.id || index} className="rounded-2xl border border-slate-200 p-4 space-y-2 bg-white">
                    <p className="text-sm"><span className="font-medium text-slate-600">Txn ID:</span><br /><span className="font-semibold break-all">{tx.id}</span></p>
                    <div className="flex justify-between text-sm"><span className="text-slate-600">Amount</span><span className="font-semibold">₹{tx.amount}</span></div>
                    <div className="flex justify-between text-sm"><span className="text-slate-600">Status</span><span className={`font-semibold ${tx.status === "SUCCESS" ? "text-emerald-600" : tx.status === "FAILED" ? "text-rose-600" : "text-amber-600"}`}>{tx.status}</span></div>
                    {tx.customerSummary && <p className="text-xs text-slate-500">{tx.customerSummary}</p>}
                  </div>
                ))}
                <div className="pt-4 space-y-3">
                  <button onClick={() => navigate("/remittance")} className="w-full py-3 rounded-xl bg-slate-200 font-semibold">New Transfer</button>
                  <button onClick={handlePrint} className="w-full py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-indigo-600 to-cyan-500">Print Receipt</button>
                  <button onClick={() => handleDownloadPdf(record)} className="mt-2 w-full py-2 rounded-lg bg-green-600 text-white text-sm font-semibold">Download PDF</button>
                </div>
              </div>

              <div className="hidden md:block p-6">
                <h2 className="text-xl font-semibold mb-4">Transaction Summary</h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-slate-100">
                      <tr>
                        <th className="px-4 py-3 text-left">Txn ID</th>
                        <th className="px-4 py-3 text-right">Amount</th>
                        <th className="px-4 py-3 text-center">Status</th>
                        <th className="px-4 py-3 text-left">Description</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200">
                      {transactions.map((tx) => (
                        <tr key={tx.id} className="hover:bg-slate-50">
                          <td className="px-4 py-3">{tx.id}</td>
                          <td className="px-4 py-3 text-right">₹{tx.amount}</td>
                          <td className="px-4 py-3 text-center"><span className={`font-semibold ${tx.status === "SUCCESS" ? "text-emerald-600" : tx.status === "FAILED" ? "text-rose-600" : "text-amber-600"}`}>{tx.status}</span></td>
                          <td className="px-4 py-3">{tx.customerSummary}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="flex justify-end gap-4 mt-6">
                  <button onClick={() => navigate("/remittance")} className="px-6 py-2 rounded-xl bg-slate-200">New Transfer</button>
                  <button onClick={handlePrint} className="px-6 py-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-cyan-500">Print</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FundTransfer;